import React from 'react';

const NumberTwo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="106" viewBox="0 0 62 106">
    <path fill="#303940" fillRule="evenodd" d="M16.08 38.16H1.92c-.96 0-1.8-.84-1.8-1.8V13.68C.12 6.12 6.24 0 13.8 0h33.84c7.56 0 13.68 6.12 13.68 13.68V35.4c0 4.56-2.28 8.88-6.12 11.4L18.6 71.4c-.48.36-.84.96-.84 1.56v12.6c0 .96.84 1.8 1.8 1.8h22.08c.96 0 1.8-.84 1.8-1.8V69.12c0-.96.84-1.8 1.8-1.8h14.04c.96 0 1.8.84 1.8 1.8v34.2c0 .96-.84 1.8-1.8 1.8H1.8c-.96 0-1.8-.84-1.8-1.8V69.84c0-4.56 2.28-8.88 6.12-11.4l36.6-24.6c.48-.36.84-.96.84-1.56V19.44c0-.96-.84-1.8-1.8-1.8H19.68c-.96 0-1.8.84-1.8 1.8v16.92c0 .96-.84 1.8-1.8 1.8z" />
  </svg>
);

export default NumberTwo;